import React, { useState } from 'react';

const InscricaoBlueSaude = () => {
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    cpf: '',
    rg: '',
    dataNascimento: '',
    sexo: '',
    estadoCivil: '',
    telefone: '',
    celular: '',
    email: '',
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    profissao: '',
    renda: '',
    planoEscolhido: '',
    dependentes: [],
    termos: false
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const planos = [
    {
      nome: 'Blue Saúde Básico',
      preco: 'R$ 89,90',
      cobertura: [
        'Consultas médicas',
        'Exames básicos',
        'Emergência 24h',
        'Rede credenciada nacional'
      ]
    },
    {
      nome: 'Blue Saúde Completo',
      preco: 'R$ 149,90',
      cobertura: [
        'Todas as coberturas do Básico',
        'Exames especializados',
        'Cirurgias eletivas',
        'Internação hospitalar',
        'Fisioterapia'
      ]
    },
    {
      nome: 'Blue Saúde Premium',
      preco: 'R$ 249,90',
      cobertura: [
        'Todas as coberturas do Completo',
        'Medicina preventiva',
        'Check-up anual',
        'Cobertura internacional',
        'Quarto privativo'
      ]
    }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpar erro quando o usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.nomeCompleto.trim()) newErrors.nomeCompleto = 'Nome completo é obrigatório';
    if (!formData.cpf.trim()) newErrors.cpf = 'CPF é obrigatório';
    if (!formData.email.trim()) newErrors.email = 'Email é obrigatório';
    if (!formData.telefone.trim()) newErrors.telefone = 'Telefone é obrigatório';
    if (!formData.planoEscolhido) newErrors.planoEscolhido = 'Selecione um plano';
    if (!formData.termos) newErrors.termos = 'Você deve aceitar os termos';
    
    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Simular envio do formulário
      console.log('Dados do formulário:', formData);
      setShowSuccess(true);
      
      // Resetar formulário após 3 segundos
      setTimeout(() => {
        setShowSuccess(false);
        setFormData({
          nomeCompleto: '',
          cpf: '',
          rg: '',
          dataNascimento: '',
          sexo: '',
          estadoCivil: '',
          telefone: '',
          celular: '',
          email: '',
          cep: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          profissao: '',
          renda: '',
          planoEscolhido: '',
          dependentes: [],
          termos: false
        });
      }, 3000);
    }
  };

  if (showSuccess) {
    return (
      <div className="pt-32 min-h-screen bg-focus-white flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md mx-4 text-center">
          <div className="text-6xl mb-4">✅</div>
          <h2 className="text-2xl font-bold text-focus-blue mb-4">
            Inscrição Enviada com Sucesso!
          </h2>
          <p className="text-gray-600 mb-6">
            Recebemos sua inscrição para o Blue Saúde. Nossa equipe entrará em contato em até 24 horas para finalizar o processo.
          </p>
          <div className="bg-focus-pink p-4 rounded-lg">
            <p className="text-sm text-gray-700">
              <strong>Próximos passos:</strong><br/>
              1. Análise da documentação<br/>
              2. Contato para confirmação<br/>
              3. Ativação do plano
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-32 bg-focus-white min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-focus-blue to-blue-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Inscrição Blue Saúde
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            Preencha o formulário abaixo para se inscrever no plano de saúde Blue Saúde
          </p>
        </div>
      </section>

      {/* Planos Disponíveis */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
            Escolha seu Plano
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {planos.map((plano, index) => (
              <div
                key={index}
                className={`rounded-lg shadow-lg p-6 border-2 transition-all cursor-pointer ${
                  formData.planoEscolhido === plano.nome
                    ? 'border-focus-blue bg-focus-pink'
                    : 'border-gray-200 bg-white hover:border-focus-blue'
                }`}
                onClick={() => setFormData(prev => ({ ...prev, planoEscolhido: plano.nome }))}
              >
                <h3 className="text-xl font-bold text-focus-blue mb-2">{plano.nome}</h3>
                <div className="text-2xl font-bold text-focus-orange mb-4">{plano.preco}<span className="text-sm text-gray-600">/mês</span></div>
                <ul className="space-y-2">
                  {plano.cobertura.map((item, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <svg className="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário de Inscrição */}
      <section className="py-16 bg-focus-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-focus-blue text-center mb-12">
              Dados para Inscrição
            </h2>
            
            <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-8">
              {/* Dados Pessoais */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Dados Pessoais
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      name="nomeCompleto"
                      value={formData.nomeCompleto}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue ${
                        errors.nomeCompleto ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="Digite seu nome completo"
                    />
                    {errors.nomeCompleto && <p className="text-red-500 text-sm mt-1">{errors.nomeCompleto}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CPF *
                    </label>
                    <input
                      type="text"
                      name="cpf"
                      value={formData.cpf}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue ${
                        errors.cpf ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="000.000.000-00"
                    />
                    {errors.cpf && <p className="text-red-500 text-sm mt-1">{errors.cpf}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      RG
                    </label>
                    <input
                      type="text"
                      name="rg"
                      value={formData.rg}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="00.000.000-0"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Data de Nascimento
                    </label>
                    <input
                      type="date"
                      name="dataNascimento"
                      value={formData.dataNascimento}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sexo
                    </label>
                    <select
                      name="sexo"
                      value={formData.sexo}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                    >
                      <option value="">Selecione</option>
                      <option value="masculino">Masculino</option>
                      <option value="feminino">Feminino</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado Civil
                    </label>
                    <select
                      name="estadoCivil"
                      value={formData.estadoCivil}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                    >
                      <option value="">Selecione</option>
                      <option value="solteiro">Solteiro(a)</option>
                      <option value="casado">Casado(a)</option>
                      <option value="divorciado">Divorciado(a)</option>
                      <option value="viuvo">Viúvo(a)</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Contato */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Contato
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Telefone *
                    </label>
                    <input
                      type="tel"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue ${
                        errors.telefone ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="(11) 1234-5678"
                    />
                    {errors.telefone && <p className="text-red-500 text-sm mt-1">{errors.telefone}</p>}
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Celular
                    </label>
                    <input
                      type="tel"
                      name="celular"
                      value={formData.celular}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="(11) 99999-9999"
                    />
                  </div>
                  
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue ${
                        errors.email ? 'border-red-500' : 'border-gray-300'
                      }`}
                      placeholder="seu@email.com"
                    />
                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                  </div>
                </div>
              </div>

              {/* Endereço */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Endereço
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CEP
                    </label>
                    <input
                      type="text"
                      name="cep"
                      value={formData.cep}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="00000-000"
                    />
                  </div>
                  
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Endereço
                    </label>
                    <input
                      type="text"
                      name="endereco"
                      value={formData.endereco}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="Rua, Avenida, etc."
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Número
                    </label>
                    <input
                      type="text"
                      name="numero"
                      value={formData.numero}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="123"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Complemento
                    </label>
                    <input
                      type="text"
                      name="complemento"
                      value={formData.complemento}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="Apto, Bloco, etc."
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Bairro
                    </label>
                    <input
                      type="text"
                      name="bairro"
                      value={formData.bairro}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="Nome do bairro"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Cidade
                    </label>
                    <input
                      type="text"
                      name="cidade"
                      value={formData.cidade}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="Nome da cidade"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Estado
                    </label>
                    <select
                      name="estado"
                      value={formData.estado}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                    >
                      <option value="">Selecione</option>
                      <option value="SP">São Paulo</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="PR">Paraná</option>
                      <option value="SC">Santa Catarina</option>
                      {/* Adicionar outros estados conforme necessário */}
                    </select>
                  </div>
                </div>
              </div>

              {/* Informações Profissionais */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Informações Profissionais
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Profissão
                    </label>
                    <input
                      type="text"
                      name="profissao"
                      value={formData.profissao}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                      placeholder="Sua profissão"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Renda Mensal
                    </label>
                    <select
                      name="renda"
                      value={formData.renda}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-focus-blue"
                    >
                      <option value="">Selecione</option>
                      <option value="ate-2sm">Até 2 salários mínimos</option>
                      <option value="2-5sm">De 2 a 5 salários mínimos</option>
                      <option value="5-10sm">De 5 a 10 salários mínimos</option>
                      <option value="acima-10sm">Acima de 10 salários mínimos</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Plano Escolhido */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-focus-blue mb-6 border-b border-gray-200 pb-2">
                  Plano Escolhido
                </h3>
                <div className="bg-focus-pink p-4 rounded-lg">
                  {formData.planoEscolhido ? (
                    <p className="text-focus-blue font-semibold">
                      Plano selecionado: {formData.planoEscolhido}
                    </p>
                  ) : (
                    <p className="text-gray-600">
                      Selecione um plano acima para continuar
                    </p>
                  )}
                  {errors.planoEscolhido && <p className="text-red-500 text-sm mt-1">{errors.planoEscolhido}</p>}
                </div>
              </div>

              {/* Termos e Condições */}
              <div className="mb-8">
                <div className="flex items-start">
                  <input
                    type="checkbox"
                    name="termos"
                    checked={formData.termos}
                    onChange={handleInputChange}
                    className="mt-1 mr-3"
                  />
                  <label className="text-sm text-gray-700">
                    Eu aceito os <a href="#" className="text-focus-blue hover:underline">termos e condições</a> e 
                    a <a href="#" className="text-focus-blue hover:underline">política de privacidade</a> do Blue Saúde. *
                  </label>
                </div>
                {errors.termos && <p className="text-red-500 text-sm mt-1">{errors.termos}</p>}
              </div>

              {/* Botão de Envio */}
              <div className="text-center">
                <button
                  type="submit"
                  className="bg-focus-blue hover:bg-blue-700 text-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
                >
                  Enviar Inscrição
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InscricaoBlueSaude;